module.exports = __webpack_public_path__ + "static/media/ecp.cf0cf345.svg";